<div (mouseenter)="setElemHidden('phone-number-href', false)" (mouseleave)="setElemHidden('phone-number-href', true)"
     (click)="toggleElemHidden('phone-number-href')" class="contact">
  <a hidden id="phone-number-href" class="phone-number" [href]="'tel:'+phoneNumber">{{ phoneNumber }}</a>
  <div id="phone-icon"></div>
</div>
